import React, { useState } from 'react';
import SearchBox from 'react-search-box';
import { testData } from './constants';

const SearchComponent = ({ onSelectRecord }) => {

  const data = Object.entries(testData).flatMap(([category, tests]) =>
    Object.entries(tests).map(([name, price]) => ({
      key: name,
      value: `${name} (${category}) - Rs. ${price}`,
      price:price
    }))
  );

  const handleSearch = (record) => {
    if (record) {
      console.log(record);
      onSelectRecord(record);
    }
  };

  return (
    <div>
      <SearchBox
        data={data}
        placeholder="Search here..."
        onSelect={handleSearch}
        onChange={handleSearch}
      />
    </div>
  );
};

export default SearchComponent;
